import { render, staticRenderFns } from "./GendecRules.vue?vue&type=template&id=63cf89f2&scoped=true"
import script from "./GendecRules.vue?vue&type=script&lang=js"
export * from "./GendecRules.vue?vue&type=script&lang=js"
import style0 from "./GendecRules.vue?vue&type=style&index=0&id=63cf89f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf89f2",
  null
  
)

export default component.exports